import React from 'react'
import { motion } from 'framer-motion'
import './ListItemCard.css'
export default function ListItemCard(props) {
    return (
        <motion.li className={`list-item-card ${props.isActive ? 'active' : ''} container-horizontal gap-8 fw-semibold fs-medium ${props.className}`}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            initial={props.initial}
            whileInView={props.whileInView}
            transition={props.transition}
            viewport={{
                once: true
            }}
            onClick={props.onClick ?? null}
            style={{
                'cursor' : props.onClick != null ? 'pointer' : 'default'
            }}

        >
            <motion.div
                initial={
                    {
                        scale: 0,
                    }
                }

                whileInView={{
                    scale: 1
                }}
                className='icon'>
                {props.icon}
            </motion.div>

            {props.title}
        </motion.li>
    )
}
